var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-slider"},[(_vm.slidesHtml)?_c('tiny-slider',_vm._b({ref:"slider",domProps:{"innerHTML":_vm._s(_vm.slidesHtml)},on:{"transitionStart":_vm.onTransitionStart,"indexChanged":_vm.onIndexChange,"transitionEnd":_vm.onTransitionEnd}},'tiny-slider',_vm.options,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }